<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
export default {
  data() {
    return {};
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <a href="#" class="logo-footer">
              <img src="/images/logo-light.png" height="24" alt="" />
            </a>
            <p class="mt-4">
              Document Support INC provides professional documentation and support solutions
              to help your business succeed.
            </p>
            <!-- <ul class="list-unstyled social-icon social mb-0 mt-4">
              <li class="list-inline-item">
                <a href="javascript:void(0)" class="rounded">
                  <facebook-icon class="fea icon-sm fea-social"></facebook-icon>
                </a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)" class="rounded">
                  <instagram-icon
                    class="fea icon-sm fea-social"
                  ></instagram-icon>
                </a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)" class="rounded">
                  <twitter-icon class="fea icon-sm fea-social"></twitter-icon>
                </a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)" class="rounded">
                  <linkedin-icon class="fea icon-sm fea-social"></linkedin-icon>
                </a>
              </li>
            </ul> -->
            <!--end icon-->
          </div>
          <!--end col-->

          <div class="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">Menu</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <router-link to="/" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> About Us</router-link
                >
              </li>
              <li>
                <router-link to="/contact-us" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Contact Us</router-link
                >
              </li>
            </ul>
          </div>
          <!--end col-->

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">Products & Services</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <router-link to="/products/sharp" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Sharp</router-link
                >
              </li>
              <li>
                <router-link to="/products/konica-minolta" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Konica Minolta</router-link
                >
              </li>
              <li>
                <router-link to="/products/lexmark" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Lexmark</router-link
                >
              </li>
              <li>
                <router-link to="/products/hp" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> HP <span class="badge badge-warning ml-1">Soon</span></router-link
                >
              </li>
              <li>
                <router-link to="/products/brother" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Brother <span class="badge badge-warning ml-1">Soon</span></router-link
                >
              </li>
            </ul>
          </div>
          <!--end col-->

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">Contact Info</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li class="d-flex">
                <i class="mdi mdi-account mr-2 mt-1"></i>
                <div>
                  <p class="mb-1">Flora Levi</p>
                </div>
              </li>
              <li class="d-flex mt-3">
                <i class="mdi mdi-email mr-2 mt-1"></i>
                <div>
                  <a href="mailto:dsi@dsincpr.com" class="text-foot">dsi@dsincpr.com</a>
                </div>
              </li>
              <li class="d-flex mt-3">
                <i class="mdi mdi-phone mr-2 mt-1"></i>
                <div>
                  <p class="mb-0">Office: 787-294-9663</p>
                  <p class="mb-0">Mobile: 787-587-4369</p>
                </div>
              </li>
              <li class="d-flex mt-3">
                <i class="mdi mdi-map-marker mr-2 mt-1"></i>
                <div>
                  <p class="mb-0">Urb Country Club</p>
                  <p class="mb-0">MM7 Calle 420</p>
                  <p class="mb-0">Carolina, PR</p>
                </div>
              </li>
            </ul>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
    <footer class="footer footer-bar">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-sm-6">
            <div class="text-sm-left">
              <p class="mb-0">
                © {{ new Date().getFullYear() }} Document Support INC (DSI). All rights reserved.
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <!-- <ul class="list-unstyled text-sm-right mb-0">
              <li class="list-inline-item">
                <a href="javascript:void(0)"
                  ><img
                    src="images/payments/american-ex.png"
                    class="avatar avatar-ex-sm"
                    title="American Express"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="images/payments/discover.png"
                    class="avatar avatar-ex-sm"
                    title="Discover"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="images/payments/master-card.png"
                    class="avatar avatar-ex-sm"
                    title="Master Card"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="images/payments/paypal.png"
                    class="avatar avatar-ex-sm"
                    title="Paypal"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="images/payments/visa.png"
                    class="avatar avatar-ex-sm"
                    title="Visa"
                    alt=""
                /></a>
              </li>
            </ul> -->
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
  </div>
</template>
